import trendingPlaylistSagas from './lineups/collections/sagas'
const sagas = () => [...trendingPlaylistSagas()]
export default sagas
